export const taskCenterTrackingIds = {
  topBarButton: 'task-center-top-bar-button',
  panelHeaderCloseButton: 'task-center-close-panel',
  backButton: 'task-center-back-button',
  createTaskDraftButton: 'task-center-create-task-draft-button',
  createTaskButton: 'task-center-create-task-button',
  tabTodo: 'task-center-tab-todo',
  tabInprogress: 'task-center-tab-in-progress',
  tabDone: 'task-center-tab-done',
  deleteTaskFromDetails: 'task-center-delete-task-from-details',
  deleteTaskCancel: 'task-center-delete-task-cancel',
  deleteTaskConfirm: 'task-center-delete-task-confirm',
  editTaskFromDetails: 'task-center-edit-task-from-details',
  openTaskDetailsOptions: 'task-center-open-task-details-options',
  list: {
    openTaskOptions: 'task-center-open-task-options',
    openTaskDetails: 'task-center-open-task-details',
    markAsTodo: 'task-center-mark-as-todo',
    markAsInProgress: 'task-center-mark-as-in-progress',
    markAsDone: 'task-center-mark-as-done',
    editTaskFromList: 'task-center-edit-task-from-list',
    deleteTaskFromList: 'task-center-delete-task-from-list',
    switchTaskFromTaskList: 'task-center-switch-task-task-list',
  },
  edit: {
    cancelProgressButton: 'task-center-edit-cancel-edit-progress-button',
    saveProgressButton: 'task-center-edit-save-progress-button',
    cancelProgressBackButton: 'task-center-cancel-edit-progress-back-button',
    locationDropdown: 'task-center-edit-location-dropdown',
    removeLocationValue: 'task-center-edit-remove-location-value',
    dueDateDropdown: 'task-center-edit-due-date-dropdown',
    removeDueDateValue: 'task-center-edit-remove-due-date-value',
    patientDropdown: 'task-center-edit-patient-dropdown',
    removePatientValue: 'task-center-edit-remove-patient-value',
    assigneeDropdown: 'task-center-edit-assignee-dropdown',
    removeAssigneeValue: 'task-center-edit-remove-assignee-value',
    statusDropdown: 'task-center-edit-status-dropdown',
    priorityDropdown: 'task-center-edit-priority-dropdown',
    removePriorityValue: 'task-center-edit-remove-priority-value',
  },
  create: {
    cancelProgressButton: 'task-center-create-cancel-create-progress-button',
    saveProgressButton: 'task-center-create-save-progress-button',
    cancelProgressBackButton: 'task-center-cancel-create-progress-back-button',
    locationDropdown: 'task-center-create-location-dropdown',
    removeLocationValue: 'task-center-create-remove-location-value',
    dueDateDropdown: 'task-center-create-due-date-dropdown',
    removeDueDateValue: 'task-center-create-remove-due-date-value',
    patientDropdown: 'task-center-create-patient-dropdown',
    removePatientValue: 'task-center-create-remove-patient-value',
    assigneeDropdown: 'task-center-create-assignee-dropdown',
    removeAssigneeValue: 'task-center-create-remove-assignee-value',
    statusDropdown: 'task-center-create-status-dropdown',
    priorityDropdown: 'task-center-create-priority-dropdown',
    removePriorityValue: 'task-center-create-remove-priority-value',
  },
  view: {
    assignee: 'task-center-view-assignee',
    patient: 'task-center-view-patient',
    location: 'task-center-view-location',
    priority: 'task-center-view-priority',
    dueDate: 'task-center-view-due-date',
    status: 'task-center-view-status',
  },
  filters: {
    assigneeFilter: 'task-center-assignee-filter',
    applyAssigneeFilterButton: 'task-center-apply-assignee-filter-button',
    otherFilters: 'task-center-other-filters',
    applyOtherFiltersButton: 'task-center-apply-other-filters-button',
    priorityDescendingFilter: 'task-center-priority-ascending-filter',
    dueDateFilter: 'task-center-due-date-filter',
    sourceFilter: 'task-center-source-filter',
    createdByFilter: 'task-center-created-by-filter',
    sourceCallIntelFilter: 'task-center-source-call-intel-filter',
    sourceTaskCenterFilter: 'task-center-source-task-center-filter',
    sourceMessagingFilter: 'task-center-source-messaging-filter',
    clearOtherFiltersButton: 'task-center-clear-other-filters-button',
    clearSortFiltersButton: 'task-center-clear-sort-filters-button',
  },
  openCallIntelPanel: 'task-center-open-call-intel-panel',
  openCallIntelPanelWithCitation: 'task-center-open-call-intel-panel-with-citation',
  openMessage: 'task-center-open-message-panel',
  openMessageWithCitation: 'task-center-open-message-with-citation',
};

export const contactPanelTaskListTrackingIds = {
  createTaskButton: 'contact-panel-task-list-create-task-button',
  createTaskDraftButton: 'contact-panel-task-list-create-task-draft-button',
  filters: {
    otherFilters: 'contact-panel-task-list-other-filters',
    clearOtherFiltersButton: 'contact-panel-task-list-clear-other-filters-button',
    clearSortFiltersButton: 'contact-panel-task-list-clear-sort-filters-button',
    applyOtherFiltersButton: 'contact-panel-task-list-apply-other-filters-button',
    createdByFilter: 'contact-panel-task-list-created-by-filter',
    priorityDescendingFilter: 'contact-panel-task-list-priority-ascending-filter',
    dueDateFilter: 'contact-panel-task-list-due-date-filter',
    sourceFilter: 'contact-panel-task-list-source-filter',
    sourceCallIntelFilter: 'contact-panel-task-list-source-call-intel-filter',
    sourceTaskCenterFilter: 'contact-panel-task-list-source-task-center-filter',
    sourceMessagingFilter: 'contact-panel-task-list-source-messaging-filter',
  },
  deleteTaskCancel: 'contact-panel-task-list-delete-task-cancel',
  deleteTaskConfirm: 'contact-panel-task-list-delete-task-confirm',
  list: {
    openTaskDetails: 'contact-panel-task-list-open-task-details',
    openTaskOptions: 'contact-panel-task-list-open-task-options',
    editTaskFromList: 'contact-panel-task-list-edit-task-from-list',
    deleteTaskFromList: 'contact-panel-task-list-delete-task-from-list',
    switchTaskFromTaskList: 'contact-panel-task-list-switch-task-task-list',
    markAsTodo: 'contact-panel-task-list-mark-as-todo',
    markAsInProgress: 'contact-panel-task-list-mark-as-in-progress',
    markAsDone: 'contact-panel-task-list-mark-as-done',
  },
};
